export default {
    SET_ACTIVE_NETWORK(state, network_id) {
        if (state.loadedNetworkID == network_id) {
            return;
        }

        // reset all values
        state.loadedNetworkID = network_id;
        state.loadedTimeframe = "1w";
        state.topDomains = [];
        state.mcVersionDistribution = [];
        state.osVersionDistribution = [];
        state.attacksMitigated = 0;
        state.bandwidthUsed = 0;
        state.bounceRate = 0;
        state.uniquePlayers = 0;
        state.playerCount = [];
        state.connectionCount = [];
    },
    SET_ACTIVE_TIMEFRAME(state, timeframe) {
        if (state.loadedTimeframe == timeframe) {
            return;
        }

        // reset all values
        state.loadedTimeframe = timeframe;
        state.topDomains = [];
        state.mcVersionDistribution = [];
        state.osVersionDistribution = [];
        state.attacksMitigated = 0;
        state.bandwidthUsed = 0;
        state.bounceRate = 0;
        state.uniquePlayers = 0;
        state.playerCount = [];
        state.connectionCount = [];
    },
    UPDATE_NETWORK_PLAYERS(state, responseSeries) {
        state.playerCount = [responseSeries];
    },
    UPDATE_NETWORK_CONNECTIONS(state, responseSeries) {
        state.connectionCount = [responseSeries];
    },
    UPDATE_NETWORK_TOP_DOMAINS(state, responseRatios) {
        state.topDomains = responseRatios;
    }

    
}


